export const APP_ICONS = [
  'bell-off',
  'center',
  'england',
  'group',
  'spain',
  'trafo',
  'volta-large',
  'volta-white',
  'volta',
  'wifi-off',
  'dataflow',
  'form-input',
  'window',
  'line-close',
  'mdc',
  'line-open',
];
